export default {
  WITH_VAT: { value: true, label: "WITH_VAT", title: "Тільки з ПДВ" },
  WITHOUT_VAT: { value: false, label: "WITHOUT_VAT", title: "Тільки без ПДВ" },
  BOTH_VAT: { value: null, label: "BOTH_VAT", title: "Можливо як з ПДВ, так і без ПДВ" },
};